import { render, staticRenderFns } from "./EmailSyncList.vue?vue&type=template&id=7ca84b95&scoped=true"
import script from "./EmailSyncList.vue?vue&type=script&lang=js"
export * from "./EmailSyncList.vue?vue&type=script&lang=js"
import style0 from "./EmailSyncList.vue?vue&type=style&index=0&id=7ca84b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca84b95",
  null
  
)

export default component.exports